import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";

import { IonicModule } from "@ionic/angular";

import { ButtonModule } from "../../../shared/component/common/button/button.module";
import { HeaderModule } from "../../../shared/component/common/header/header.module";
import { InputModule } from "../../../shared/component/common/input/input.module";
import { LabelModule } from "../../../shared/component/common/label/label.module";
import { AddressNamePageComponent } from "./address-name.page";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    HeaderModule,
    ButtonModule,
    LabelModule,
    InputModule,
    ReactiveFormsModule,
  ],
  declarations: [AddressNamePageComponent],
})
export class AddressNamePageModule {}
